import SearchLandingPage from '@/components/modules/Landing/SearchLandingPage';
import { searchLandingPages } from '@/content/searchLandingPages';

const CustomGptComparisonPage = () => (
  <SearchLandingPage config={searchLandingPages.compareCustomGpt} />
);

export default CustomGptComparisonPage;
